import { createSlice } from '@reduxjs/toolkit';
import { TicketState } from './ticketTypes';
import {
    createTicket,
    fetchTicketById,
    fetchAllTickets,
    updateTicket,
    deleteTicket,
    fetchTicketSummary,
    fetchTicketsByDepartment,
    fetchTicketsSummaryByDepartment,
    fetchTicketsByEmployeeHierarchy
} from './ticketActions';

const initialState: TicketState = {
    ticket: [],
    tickets: [],
    TicketSummry: [],
    ticketsByDepartment: [],
    ticketsSummaryByDepartment: [],
    ticketsByEmployeeHierarchy: [],
    selectedTicket: undefined,
    loading: false,
    error: undefined,
};

const ticketSlice = createSlice({
    name: 'ticket',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Create Ticket
            .addCase(createTicket.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(createTicket.fulfilled, (state, action) => {
                state.loading = false;
                state.tickets.push(action.payload.data);
            })
            .addCase(createTicket.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Fetch Ticket by ID
            .addCase(fetchTicketById.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchTicketById.fulfilled, (state, action) => {
                state.loading = false;
                state.selectedTicket = action.payload.data;
            })
            .addCase(fetchTicketById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Fetch All Tickets
            .addCase(fetchAllTickets.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchAllTickets.fulfilled, (state, action) => {
                state.loading = false;
                state.tickets = action.payload.data;
            })
            .addCase(fetchAllTickets.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            // Fetch  Tickets Summary
            .addCase(fetchTicketSummary.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchTicketSummary.fulfilled, (state, action) => {
                state.loading = false;
                state.TicketSummry = action.payload.data;
            })
            .addCase(fetchTicketSummary.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            // by department
            .addCase(fetchTicketsByDepartment.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchTicketsByDepartment.fulfilled, (state, action) => {
                state.loading = false;
                state.ticketsByDepartment = action.payload.data;
            })
            .addCase(fetchTicketsByDepartment.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            // Summary by department
            .addCase(fetchTicketsSummaryByDepartment.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchTicketsSummaryByDepartment.fulfilled, (state, action) => {
                state.loading = false;
                state.ticketsSummaryByDepartment = action.payload.data;
            })
            .addCase(fetchTicketsSummaryByDepartment.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Update Ticket
            .addCase(updateTicket.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(updateTicket.fulfilled, (state, action) => {
                state.loading = false;
                const index = state.tickets.findIndex((ticket: any) => ticket.id === action.payload.id);
                if (index !== -1) {
                    state.tickets[index] = action.payload;
                }
            })
            .addCase(updateTicket.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Delete Ticket
            .addCase(deleteTicket.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(deleteTicket.fulfilled, (state, action) => {
                state.loading = false;
                state.tickets = state.tickets.filter(ticket => ticket.id !== action.payload.id);
            })
            .addCase(deleteTicket.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(fetchTicketsByEmployeeHierarchy.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchTicketsByEmployeeHierarchy.fulfilled, (state, action) => {
                state.loading = false;
                state.ticketsByEmployeeHierarchy = action.payload.data; // Assuming payload has `data`
            })
            .addCase(fetchTicketsByEmployeeHierarchy.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export default ticketSlice.reducer;
